import { useMemo } from "react";
import { isServer } from "../../utils/environmentDetection/library";

export default function usePubSub() {
    return useMemo(() => {
        if (isServer() || !window.CBC?.APP?.PubSub) {
            return {
                subscribe: () => {},
                unsubscribe: () => {},
            };
        } else {
            return window.CBC.APP.PubSub;
        }
    }, []);
}
